import HttpService from '../HttpService'

const _http = new HttpService()
export default {

  showByRecordingMedia: (id) => {
    return _http.get(`/api/audio-visual/media-subject-drafts/show-by-recording-media/${id}`)
  }
}